import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Models
import PaymentModel from 'models/Payment'

// Services
import dialog from 'services/dialog'
import message from 'services/message'

// Helpers
import { resolveErrorMessage } from 'helpers'

// Use
import useMounted from 'use/mounted'

// Api
import { confirmPaymentReceived } from 'api/payment'

// Components
import Text from 'ui/Text'

function PaymentReceived({ payment }) {
  const isMounted = useMounted()

  // State
  const [isChecked, setIsChecked] = useState(false)
  const [paymentReceivedAt, setPaymentReceivedAt] = useState('')

  useEffect(() => {
    setIsChecked(!!payment.paymentReceived)
    setPaymentReceivedAt(payment.paymentReceivedAt)
  }, [payment.paymentReceived, payment.paymentReceivedAt])

  const onConfirmClick = () => {
    if (isChecked) {
      return
    }

    dialog.confirm({
      size: 'mdx',
      title: (
        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
          Confirm payment received
        </span>
      ),
      message: (
        <>
          <Text color="#000000" size={17}>
            Are you sure that you are have received the payment amount mentioned
            in this page?
          </Text>
          <br />
          <Text color="#000000" size={17}>
            Once confirmed, you can no longer uncheck the tickbox.
          </Text>
        </>
      ),
      onCancel: ({ setVisible }) => {
        setVisible(false)
      },
      onConfirm: async ({ setVisible, setLoading }) => {
        setLoading(true)
        try {
          const paymentReceivedDate = await confirmPaymentReceived(payment.id)
          if (isMounted.current) {
            setPaymentReceivedAt(paymentReceivedDate)
            setIsChecked(true)
            setVisible(false)
          }
        } catch (error) {
          message.error(await resolveErrorMessage(error))
        } finally {
          if (isMounted.current) {
            setLoading(false)
          }
        }
      },
    })
  }

  return (
    <div style={{ padding: '40px 0 0' }}>
      <div>
        <p style={{ fontSize: '20px', margin: 0, fontWeight: 'bold' }}>
          Received?
        </p>
      </div>

      <div>
        <p style={{ paddingBottom: '5px', margin: 0 }}>
          Please confirm that you have received the payment
        </p>
        <p
          style={{
            margin: 0,
            paddingBottom: '10px',
            lineHeight: '20px',
            color: '#606060',
          }}
        >
          Note: Date and time will be captured upon confirmation and you may no
          longer uncheck the box after
        </p>
      </div>
      <div>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => {}}
          style={{ margin: '4px' }}
          onClick={onConfirmClick}
        />

        <label
          htmlFor="checkbox"
          style={{ lineHeight: '30px' }}
          onClick={onConfirmClick}
        >
          I confirm that I have received the net amount paid stated above
        </label>

        {isChecked && (
          <p style={{ color: '#606060', padding: '5px 0 0 20px' }}>
            <i>Confirmed {paymentReceivedAt}</i>
          </p>
        )}
      </div>
    </div>
  )
}

PaymentReceived.propTypes = {
  payment: PropTypes.instanceOf(PaymentModel),
}

PaymentReceived.defaultProps = {
  payment: new PaymentModel(),
}

export default PaymentReceived
